export default __webpack_public_path__ + "static/media/Covid_19_India.286842f8.jpeg";